import {
  number,
  object,
  type output,
  string,
} from 'zod';

export const MIN_JUDGING_QUESTION_WEIGHT = 1;
export const MAX_JUDGING_QUESTION_WEIGHT = 100;

export const judgingQuestionValidationSchema = object({
  question: string().min(1, 'Enter a question.'),
  weight: number({ error: 'Enter a weight.' })
    .min(MIN_JUDGING_QUESTION_WEIGHT, {
      error: (issue) => issue.input === 0
        ? 'Enter a weight.'
        : 'Enter a weight from 1 to 100.',
    })
    .max(MAX_JUDGING_QUESTION_WEIGHT, 'Enter a weight from 1 to 100.'),
});

export type JudgingQuestionValidation = output<typeof judgingQuestionValidationSchema>;
